<style lang="stylus">
    .firstclonebox
        .firstclonebox-content
            display flex
            margin-bottom 32px

            .firstclonebox-vip
                margin-right 8px

            .firstclonebox-text
                display flex
                flex-wrap wrap

                p
                    font-size 12px
                    line-height 16px
                    color #222222

                p:not(:last-child)
                    margin-bottom 8px

        .firstclonebox-footer
            display flex
            justify-content flex-end
            div:not(:last-child)
                margin-right 16px
            pcStyleBtn()

        &.dark-theme__firstclonebox
            .firstclonebox-content
                .firstclonebox-text
                    p
                        color #fff
</style>
<template>
    <PCStyleModal @closeModal="closeModal" :title="!!type ? $t('vip') : $t('clone')" :width="304">
        <div class="firstclonebox" :class="{ 'dark-theme__firstclonebox': isPCDarkMode == 2 }">
            <template v-if="type == 0">
                <div class="firstclonebox-content">
                    <div class="firstclonebox-vip">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_i_10496_290972)">
                                <path
                                    d="M24.9642 2H7.03575C5.99396 2 5.04318 2.5935 4.58561 3.52943L0.778183 11.3174C0.304943 12.2853 0.445971 13.4412 1.13807 14.267L13.9098 29.506C14.9998 30.8066 17.0002 30.8066 18.0902 29.506L30.8619 14.267C31.554 13.4412 31.6951 12.2853 31.2218 11.3174L27.4144 3.52943C26.9568 2.5935 26.006 2 24.9642 2Z"
                                    fill="url(#paint0_linear_10496_290972)"
                                />
                            </g>
                            <path
                                d="M9 14H11L16 21L21 14H23"
                                stroke="white"
                                stroke-opacity="0.8"
                                stroke-width="3"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <defs>
                                <filter
                                    id="filter0_i_10496_290972"
                                    x="0.500977"
                                    y="2"
                                    width="30.998"
                                    height="31.4805"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                >
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                                    <feColorMatrix
                                        in="SourceAlpha"
                                        type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                        result="hardAlpha"
                                    />
                                    <feOffset dy="3" />
                                    <feGaussianBlur stdDeviation="2" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.898667 0 0 0 0 0.366667 0 0 0 0.3 0" />
                                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_10496_290972" />
                                </filter>
                                <linearGradient
                                    id="paint0_linear_10496_290972"
                                    x1="5"
                                    y1="2"
                                    x2="27.5858"
                                    y2="28.5007"
                                    gradientUnits="userSpaceOnUse"
                                >
                                    <stop stop-color="#FFE884" />
                                    <stop offset="1" stop-color="#FE9300" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                    <div class="firstclonebox-text">
                        <p v-html="$t('vipFirstTip')"></p>
                        <p v-html="$t('vipFirstTip2')"></p>
                    </div>
                </div>

                <div class="firstclonebox-footer">
                    <div class="pcstyle-btn vip-btn" @click="toVip">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M11 18C11 18.5523 10.5523 19 10 19C9.44772 19 9 18.5523 9 18C9 17.4477 9.44772 17 10 17C10.5523 17 11 17.4477 11 18Z"
                                fill="#4A320E"
                            />
                            <path
                                d="M17 18C17 18.5523 16.5523 19 16 19C15.4477 19 15 18.5523 15 18C15 17.4477 15.4477 17 16 17C16.5523 17 17 17.4477 17 18Z"
                                fill="#4A320E"
                            />
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M4 5.5C4 5.22386 4.22386 5 4.5 5H6.64632C7.12513 5 7.53675 5.33941 7.62799 5.80945L9.33342 14.5954C9.37904 14.8304 9.58485 15.0001 9.82426 15.0001L17.5 15C17.7761 15 18 15.2238 18 15.5C18 15.7761 17.7762 16 17.5 16L9.82428 16.0001C9.10605 16.0001 8.4886 15.491 8.35174 14.786L6.64632 6H4.5C4.22386 6 4 5.77614 4 5.5Z"
                                fill="#4A320E"
                            />
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M18.4098 8H7.5V7H18.4098C19.0277 7 19.4978 7.55487 19.3962 8.1644L18.6325 12.7466C18.5119 13.4699 17.8861 14 17.1529 14H9V13H17.1529C17.3973 13 17.6059 12.8233 17.6461 12.5822L18.4098 8Z"
                                fill="#4A320E"
                            />
                        </svg>
                        <p>{{ $t("vip") }}</p>
                    </div>
                    <div class="pcstyle-btn gray-btn" @click="toClone">
                        <p>{{ $t("buynow") }}</p>
                    </div>
                </div>
            </template>

            <template v-else>
                <div class="firstclonebox-content">
                    <div class="firstclonebox-vip">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_i_10496_290972)">
                                <path
                                    d="M24.9642 2H7.03575C5.99396 2 5.04318 2.5935 4.58561 3.52943L0.778183 11.3174C0.304943 12.2853 0.445971 13.4412 1.13807 14.267L13.9098 29.506C14.9998 30.8066 17.0002 30.8066 18.0902 29.506L30.8619 14.267C31.554 13.4412 31.6951 12.2853 31.2218 11.3174L27.4144 3.52943C26.9568 2.5935 26.006 2 24.9642 2Z"
                                    fill="url(#paint0_linear_10496_290972)"
                                />
                            </g>
                            <path
                                d="M9 14H11L16 21L21 14H23"
                                stroke="white"
                                stroke-opacity="0.8"
                                stroke-width="3"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <defs>
                                <filter
                                    id="filter0_i_10496_290972"
                                    x="0.500977"
                                    y="2"
                                    width="30.998"
                                    height="31.4805"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                >
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                                    <feColorMatrix
                                        in="SourceAlpha"
                                        type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                        result="hardAlpha"
                                    />
                                    <feOffset dy="3" />
                                    <feGaussianBlur stdDeviation="2" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.898667 0 0 0 0 0.366667 0 0 0 0.3 0" />
                                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_10496_290972" />
                                </filter>
                                <linearGradient
                                    id="paint0_linear_10496_290972"
                                    x1="5"
                                    y1="2"
                                    x2="27.5858"
                                    y2="28.5007"
                                    gradientUnits="userSpaceOnUse"
                                >
                                    <stop stop-color="#FFE884" />
                                    <stop offset="1" stop-color="#FE9300" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                    <div class="firstclonebox-text">
                        <p v-html="$t('cloneTip')"></p>
                    </div>
                </div>

                <div class="firstclonebox-footer">
                    <div class="pcstyle-btn blue-btn" @click="toUse">
                        <p>{{ $t("confirm") }}</p>
                    </div>
                </div>
            </template>
        </div>
    </PCStyleModal>
</template>
<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import PCStyleModal from "./PCStyleModal.vue";

    @Component({
        components: {
            PCStyleModal,
        },
    })
    export default class FirstCloneFreeModal extends Vue {
        @Prop()
        type;

        closeModal() {
            this.$emit("closeModal");
        }
        toVip() {
            this.$emit("toVip");
            this.$emit("closeModal");
        }
        toClone() {
            this.$emit("clone");
        }
        toUse() {
            this.$emit("toUse");
        }
        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {
        "vip": "开通VIP",
        "vipFirstTip": "开通vip，立享首次使用模板免单福利！",
        "vipFirstTip2": "<b>还能获得大额模板金！</b>",
        "buynow": "直接购买",
        "clone": "使用模板",
        "cloneTip": "您已成为会员，可享受首次使用任意付费导图免单福利。",
        "confirm": "确定"
    },
    "en": {
        "vip": "Upgrade to Premium",
        "vipFirstTip": "Upgrade now and get a paid template for free.",
        "vipFirstTip2": "<b>Plus big coupon for templates!</b>",
        "buynow": "Buy Now",
        "clone": "Use Template",
        "cloneTip": "You are now a VIP member. Enjoy your first paid template for free",
        "confirm": "Confirm"
    },
    "fr": {},
    "de": {},
    "jp": {},
    "es": {},
    "pt": {},
    "it": {},
    "tw": {},
    "kr": {}
}
</i18n>
